<template>
    <div class="properties-update">
        <OrderFormProperties
            :main-panel="mainPanel"
            :data-properties="properties"
            disabled
            @panel-handle="(value) => (mainPanel = value)"
        />

        <div class="properties-update__actions">
            <v-btn
                color="#55595c"
                dark
                small
                data-test-id="wig-page--slideout--close-btn"
                @click="closeHandle"
            >
                {{ textContent['close'] }}
            </v-btn>
            <v-btn
                color="#967adc"
                dark
                small
                data-test-id="wig-page--slideout--update-btn"
                @click="updateHandle"
            >
                {{ textContent['update'] }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import OrderFormProperties from '@/components/forms/order-form-properties'
import { actionTypes, getterTypes } from '@/store/modules/orders'
import { mapActions, mapGetters } from 'vuex'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'
import languageMixin from '@/mixins/language.mixin'

export default {
    name: 'OrderPropertiesUpdate',
    components: { OrderFormProperties },
    mixins: [languageMixin],
    emits: ['close-handle'],
    data() {
        return {
            mainPanel: 0,
            errors: {},
            fields: {
                ['wigType']: '',
                ['capSize']: '',
                ['capAdjustment']: '',
                ['topType']: '',
                ['topTypeComments']: '',
                ['front']: '',
                ['frontComments']: '',
                ['baseColor']: '',
                ['skinColor']: '',
                ['highlightsColor']: '',
                ['highlightsColorSelect']: '',
                ['typeOfHighlights']: '',
                ['skinTopHighlights']: '',
                ['frontColor']: '',
                ['highlightsColoring']: '',
                ['highlightsColoringSelect']: '',
                ['colorComments']: '',
                ['lengthFromNape']: '',
                ['lengthFromTop']: '',
                ['sideLength']: '',
                ['lengthComments']: '',
                ['hairTextureOnWefts']: '',
                ['hairTextureComments']: '',
                ['wigFullness']: '',
                ['wigFullnessAdditionalAmount']: '',
                ['wigFullnessComments']: '',
                ['weight']: '',
            },
        }
    },
    computed: {
        ...mapGetters('orders', { getOrder: getterTypes.getOrder }),
        isRepair: function () {
            return this.getOrder['is_repair']
        },
        properties: function () {
            return { fields: this.fields, errors: this.errors }
        },
        isProduction: function () {
            return (
                this.getOrder.state &&
                (this.getOrder.state.toLowerCase() === 'wigs in production' ||
                    this.getOrder.state.toLowerCase() === 'rework')
            )
        },
    },
    mounted() {
        this.selectHandle()
    },
    methods: {
        ...mapActions('orders', {
            updateProperties: actionTypes.updateProperties,
        }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
        }),
        selectHandle: function () {
            const properties = this.getOrder.properties || {}
            Object.keys(this.fields).forEach((field) => {
                this.fields[field] =
                    properties && properties[field] ? properties[field] : ''
            })
        },
        closeHandle: function () {
            this.$emit('close-handle')
        },
        isExceptions: function (key) {
            const exceptionArr = [
                'topTypeComments',
                'front',
                'frontComments',
                'colorComments',
                'lengthComments',
                'hairTextureComments',
                'wigFullnessComments',
            ]

            return !exceptionArr.includes(key)
        },

        updateHandle: function () {
            let properties = {}

            Object.keys(this.properties.fields).forEach((key) => {
                if (!this.properties.fields[key] && this.isExceptions(key))
                    return

                properties = {
                    ...properties,
                    [key]: this.properties.fields[key],
                }
            })

            const res = {
                id: this.getOrder.id,
                properties: { ...properties },
            }
            this.updateProperties(res)
                .then(() => {
                    this.success('Order has been updated')
                    this.closeHandle()
                })
                .catch(() => {
                    //TODO add logic for render errors
                    // this.errors = er
                })
        },
    },
}
</script>

<style scoped lang="scss">
.properties-update {
    padding: 15px 10px 10px;
    background: white;

    &__actions {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
}
</style>
